export * from './ArchiveCabinetIcon';
export * from './ArchiveCabinetIcon16Light';
export * from './ArchiveCabinetIcon16Regular';
export * from './ArchiveCabinetIcon16Solid';
export * from './ArchiveCabinetIcon20Light';
export * from './ArchiveCabinetIcon20Regular';
export * from './ArchiveCabinetIcon20Solid';
export * from './ArchiveCabinetIcon24Regular';
export * from './ArchiveCabinetIcon24Solid';
export * from './ArchiveCabinetIcon32Regular';
export * from './ArchiveCabinetIcon64Regular';
